import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import Form from "./Form";
import FoundInfo from "./FoundInfo";
import NotFoundInfo from "./NotFoundInfo";
import Success from "./Success";
import { useSelector } from "react-redux";
import branchApi from "../../../store/branchStore/branchApi";
import styles from './bonus_modal.module.scss';

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 0,
    borderRadius: 24,
  }
};

const SendCertificateModal = (props) => {
  const { t } = useTranslation();
  const { info } = useSelector(state => state.branchReducer);

  const {
    isOpen,
    setModal,
    certificate,
  } = props;

  const [currentForm, setCurrentForm] = useState(1);
  const [user, setUser] = useState(null);

  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState('');

  const onModalClose = () => {
    setModal(false);
    setCurrentForm(1);
  }

  const sendBonuses = () => {
    setIsSending(true);

    branchApi.postSendBranchCertificate(info.id, {
      certificate_id: certificate.id,
      phone: phone,
    })
      .then(() => {
        setCurrentForm(4)
      })
      .finally(() => {
        setIsSending(false);
      })
  }

  const renderForm = () => {
    switch (currentForm) {
      case 1:
        return <Form
          certificate={certificate}
          phone={phone}
          setPhone={setPhone}
          setError={setError}
          setUser={setUser}
          setCurrentForm={setCurrentForm}
          info={info}
        />
      case 2:
        return <FoundInfo isSending={isSending} sendBonuses={sendBonuses}  user={user} certificateName={certificate.header} bonuses={certificate.bonus_amount || 0} />
      case 3:
        return <NotFoundInfo isSending={isSending} sendBonuses={sendBonuses} phone={phone} certificateName={certificate.header} bonus={certificate.bonus_amount || 0} />
      case 4:
        return <Success closeModal={onModalClose} />
      default:
        return <Form />
    }
  }

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      style={modalStyles}
      onRequestClose={onModalClose}
    >
      <div className={styles.modal}>
        <div className={styles.container}>
          {renderForm()}
        </div>
      </div>
    </Modal>
  )
}

export default SendCertificateModal;